import { useState, useCallback } from 'react';

interface TwoPanelState {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  toggleCollapsed: () => void;
  toggleSidebar: () => void;
  closeSidebar: () => void;
}

/**
 * Encapsulates the collapsed + sidebarOpen state used by TwoPanelLayout pages
 * (AgentsPage, BlueprintsPage, InboxPage).
 */
export function useTwoPanelState(): TwoPanelState {
  const [collapsed, setCollapsed] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleCollapsed = useCallback(() => setCollapsed((c) => !c), []);
  const toggleSidebar = useCallback(() => setSidebarOpen((prev) => !prev), []);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);

  return {
    collapsed,
    setCollapsed,
    sidebarOpen,
    setSidebarOpen,
    toggleCollapsed,
    toggleSidebar,
    closeSidebar,
  };
}
